import {
  BannerBreakComponent,
  ContactHeroBannerComponent,
  FeaturedServicesComponent,
  FeaturedV2Component,
  GReviewsSectionComponent,
  HeroBannerComponent,
  HowItWorksComponent,
} from '@adminprodigydesign/axis';
import { Component } from '@angular/core';
import { Router, RouterLinkActive, RouterModule } from '@angular/router';
import {
  ContactDetails,
  ContactInfoSections,
} from '../../../assets/data/contact-banner-data';

@Component({
  selector: 'app-home',
  imports: [
    HeroBannerComponent,
    FeaturedServicesComponent,
    BannerBreakComponent,
    ContactHeroBannerComponent,
    HowItWorksComponent,
    // FaqComponent,
    GReviewsSectionComponent,
    RouterModule,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  contactDetails = ContactDetails;
  contactInfoSections = ContactInfoSections;

  featuredServices = [
    {
      title: 'Emergency Boiler Repairs',
      description: 'When a boiler turns life upside down, we’ll set you right.',
      image: '/images/boilerRepair.png',
      link: '/services/blocked-toilet',
    },
    {
      title: 'Blocked Drains',
      description:
        'Blocked drains or pipes? Panic not. We’re here to get you back on track.',
      image: '/images/blockedDrain.jpg',
      link: '/services/unblocking-drains',
    },
    {
      title: 'Gas Safe Certificate',
      description:
        'We`re Gas Safe Registered and can provide a certificate for rental and commerical properties',
      image: '/images/gassafe.jpg',
      link: '/services/sink-not-draining',
    },
    {
      title: 'Leaking Pipes',
      description: 'Don’t let leaks destroy your home. We fix them fast!',
      image: 'assets/images/leaking-pipes.jpg',
      link: '/services/leaking-pipes',
    },
    {
      title: 'Water Heater Issues',
      description: 'No hot water? Let us bring the heat back.',
      image: 'assets/images/water-heater.jpg',
      link: '/services/water-heater',
    },
  ];

  reviews = [
    {
      name: 'John Doe',
      rating: 5,
      comment: 'Great product! Highly recommend.',
      profilePic: 'https://via.placeholder.com/150',
    },
    {
      name: 'Jane Smith',
      rating: 4,
      comment: 'Good quality, but a bit expensive.',
      profilePic: 'https://via.placeholder.com/150',
    },
    {
      name: 'Alice Johnson',
      rating: 5,
      comment: 'Excellent service and fast delivery.',
      profilePic: 'https://via.placeholder.com/150',
    },
    {
      name: 'Bob Brown',
      rating: 3,
      comment: 'Average experience, nothing special.',
      profilePic: 'https://via.placeholder.com/150',
    },
  ];
}
